import React, { PureComponent } from 'react'
import mapSelectorsToProps from 'aria-viewer/core/selectors/mapSelectorsToProps'
import { connect } from 'react-redux'
import { nextPoint, isAutoPlayEnabled } from 'aria-viewer/tour/tourActions'
import { closePreview } from '../../interactive-element/actions/common'
import compose from 'recompose/compose'

class AutoPlay extends PureComponent {
    autoplay(props, instant) {
        const params = new URLSearchParams(window.location.search)
        const autoPlayDelay = (params.get('autoplaydelay') && Number(params.get('autoplaydelay')) * 1000) || 10000
        const moveToNextPoint = !(props.audioPlaying || props.countdown.playingCountdown)

        clearTimeout(this.timeout)
        if (!props.loading && props.isAutoPlayEnabled && !props.isAutoPlayBlocked) {
            this.timeout = setTimeout(
                () => {
                    //If we have reached the end of the experience,
                    if (props.hasReachedEndOfExperience) {
                        //tell our parent
                        parent && parent.postMessage('data:::end_of_tour_reached', '*')
                        //give the parent a few secnds to respond or we start over.
                        setTimeout(() => {
                            props.closePreview()
                            props.nextPoint()
                        }, 2000)
                    } else {
                        const interval = setInterval(() => {
                            if (moveToNextPoint) {
                                props.closePreview()
                                props.nextPoint()
                                clearInterval(interval)
                            }
                        }, 1000)
                    }
                },
                instant ? 0 : autoPlayDelay
            )
        }
    }
    componentDidMount() {
        this.autoplay(this.props)
    }
    componentWillReceiveProps(nextProps) {
        this.autoplay(nextProps, this.props.isAutoPlayBlocked !== nextProps.isAutoPlayBlocked)
    }
    render() {
        const {
            props: { isAutoPlayEnabled, isAutoPlayEnabledAction },
        } = this
        // do not cancel autoplay on user interaction with experience... user should just remove #autoplay
        return <div style={{ display: 'none' }} />
    }
}

const mapStateToProps = state => ({
    countdown: state.getIn(['countdown']),
    audioPlaying: state.getIn(['audioManager', 'audioPlaying']),
})

const mapDispatchToProps = dispatch => ({
    closePreview: () => {
        dispatch(closePreview())
    },
})

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    connect(
        mapSelectorsToProps([
            'isAutoPlayEnabled',
            'isAutoPlayBlocked',
            'hasReachedEndOfExperience',
            'mainMedia',
            'loading',
            'audioManager',
            'isAudioButtonVisible',
            'pointInfo',
            'isAvatarMuted',
        ]),
        {
            nextPoint,
            isAutoPlayEnabledAction: isAutoPlayEnabled,
        }
    )
)(AutoPlay)
